import { Route, Routes } from "react-router-dom";
import ErrorPage from "../../pages/ErrorPage";
import BusinessProfile from "../../pages/business/BusinessProfile";
import Assistant from "../../pages/assistant/Assistant";
import SolidityScan from "../../pages/business/SolidityScan";
import PaginatedReports from "../../pages/reports/PaginatedReports";
import ReportPage from "../../pages/reports/ReportPage";
import RetestManagement from "../../pages/retests/RetestManagent";
import RetestPage from "../../pages/retests/RetestPage";
import ModernBusinessDashboard from "../../pages/business/ModernBusinessDashboard";
import OrgSettingsPage from "../../pages/settings/OrgSettingsPage";
import BusinessResearcherProfile from "../../pages/researcher/BusinessProfile";
import CreateAssetPage from "../../pages/Assets/CreateAsset/CreateAssetPage";
import AssetInventoryPage from "../../pages/Assets/AssetInventoryPage";
import AssetDetailPage from "../../pages/Assets/AssetDetailPage";
import OnboardingDocumentationRoutes from "./OnboardingDocumentationRoutes";
import NotificationsPage from "../../pages/notifications/NotificationsPage";

const DeveloperRoutes = () => {
  return (
    <Routes>
      <Route index element={<ModernBusinessDashboard />} />

      {/* <Route path="programs/:id/edit" element={<ProgramEditor />} />
      <Route path="/create-program" element={<ProgramEditor />} /> */}
      {/* <Route path="invitation" element={<InvitationsManager />} /> */}

      <Route path="profile/*" element={<BusinessProfile />} />
      <Route path="settings/*" element={<OrgSettingsPage />} />
      <Route path="reports" element={<PaginatedReports />} />
      <Route path="reports/:id" element={<ReportPage />} />

      {/* <Route path="programs" element={<PaginatedPrograms />} />
      <Route path="programs/:id" element={<ProgramPage />} /> */}

      <Route path="assets" element={<AssetInventoryPage />} />
      <Route path="assets/:id" element={<AssetDetailPage />} />
      <Route path="assets/create/:id?" element={<CreateAssetPage />} />

      <Route path="/retests" element={<RetestManagement />} />
      <Route path="/retests/:retest_id" element={<RetestPage />} />

      <Route path="assistant/*" element={<Assistant />} />
      <Route path="solidity-scan" element={<SolidityScan />} />
      <Route path="notifications" element={<NotificationsPage />} />
      {/* 
      <Route path="payments/*" element={<PaginatedTransactions />} /> */}

      <Route path="users/researcher-profile/:username" element={<BusinessResearcherProfile />} />

      <Route path="onboarding-documentation/*" element={<OnboardingDocumentationRoutes />} />
      <Route path="/*" element={<ErrorPage />} />
    </Routes>
  );
};

export default DeveloperRoutes;
